import styled from "@emotion/styled";

const StyledSticky = styled.div<{
  height: number;
  top?: number;
  boxshadowMode?: string;
  zIndex?: string;
  isHeader?: boolean;
}>`
  position: sticky;
  width: 100%;
  z-index: ${({ theme, isHeader }) =>
    isHeader ? theme.zIndex.header : theme.zIndex.sticky};

  &.Sticky_sticky {
    height: ${({ height }) => height}px;
  }

  &.Sticky_sticky > .Sticky__content {
    position: fixed;
    top: ${({ top }) => (top ? top : 0)}px;
    left: 0;
    z-index: ${({ theme, isHeader }) =>
      isHeader ? theme.zIndex.sticky : theme.zIndex.header};
    background: ${({ theme }) => theme.colors.tone.white};
    border-top: ${({ theme, isHeader }) =>
      !isHeader ? `1px solid ${theme.colors.primary.platinumLight}` : "none"};
    box-shadow: ${({ boxshadowMode, isHeader }) =>
      boxshadowMode === "down" && !isHeader
        ? "0px 4px 4px rgba(0, 0, 0, 0.1)"
        : "none"};
  }

  .Sticky__content {
    width: 100%;
  }
`;

const StickySentinel = styled.div`
  height: 0;
`;

const StyledStickyHeaderShadow = styled.div<{
  headerTop: number;
  fallbackHeight: number;
  hideOnMobile?: boolean;
}>`
  position: fixed;
  top: calc(
    ${({ headerTop }) => headerTop}px +
      var(--sticky-header-offset, ${({ fallbackHeight }) => fallbackHeight}px)
  );
  left: 0;
  z-index: 1199;
  width: 100%;
  height: 10px;
  margin-top: -10px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: ${({ hideOnMobile }) => (hideOnMobile ? "none" : "block")};
  }
`;

export { StyledSticky, StickySentinel, StyledStickyHeaderShadow };
